import React from 'react';
import PropTypes from 'prop-types';

import {
  makeStyles,
  AppBar,
  Toolbar,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  actionBar: {
    top: 'auto',
    bottom: 0,
    backgroundColor: '#fff',
    color: '#000',
  },
  actionToolBar: {
    justifyContent: 'flex-end',
    '& > *': {
      margin: theme.spacing(0, 1)
    },
    '& > *:first-child': {
      marginLeft: 0
    },
    '& > *:last-child': {
      marginRight: 0
    }
  }
}));

const ActionBar = props => {
  const classes = useStyles();

  return(
    <AppBar position="fixed" className={classes.actionBar} component="div">
      <Toolbar className={classes.actionToolBar}>
        {props.children}
      </Toolbar>
    </AppBar>
  )
};

ActionBar.propTypes = {
  children: PropTypes.node
}

export default ActionBar;
